// Mock data untuk PT. Harkat Bangkit Jaya Landing Page

export const companyInfo = {
  name: "PT. HARKAT BANGKIT JAYA",
  tagline: "Kontraktor dan Perdagangan Umum",
  description: "PT. Harkat Bangkit Jaya adalah perusahaan yang bergerak dibidang jasa teknik, konstruksi, pemeliharaan bangunan, dan penyediaan tenaga kerja untuk layanan kebersihan indoor maupun outdoor, serta arsitektur. Sejak didirikan pada tahun 2025.",
  founded: "2025",
  address: "Jl. Bebedahan 1 No.14 Kota Tasikmalaya, Jawa Barat 46111",
  phone: "082289891300",
  email: "ptharkatbangkitjaya@gmail.com",
  whatsapp: "https://wa.me/6282289891300?text=Hallo%20PT.%20Harkat%20Bangkit%20Jaya%20%2C%20saya%20mau%20berkonsultasi"
};

export const services = [
  {
    id: 1,
    title: "Mechanical & Electrical",
    description: "Steel Construction, Installation Piping System, Installation Ducting & Plumbing, Installation Cable Power & Control (Substation), Termination Medium & High Voltage, Installation Panel.",
    icon: "Wrench"
  },
  {
    id: 2,
    title: "Construction - Architecture",
    description: "Architecture, Design Interior, Construction Civil - Fabrication, Landscape, Scale Model, Diorama & Maquette.",
    icon: "PenTool"
  },
  {
    id: 3,
    title: "Maintenance Services Building & Industry",
    description: "Cleaning Build System RAT (Rope Access Technic), Water Proofing – Inject - Sealant, Coating Flooring Epoxy, Chemical Anchor, FRP Linning, Protective Coating.",
    icon: "Building2"
  },
  {
    id: 4,
    title: "General Supplier",
    description: "Tools Equipment Industry & Oil-Gas, Consumable, Supply Labour.",
    icon: "Package"
  }
];

export const visionMission = {
  vision: [
    "PT. HARKAT berkomitmen pada KESELAMATAN DIUTAMAKAN",
    "PT. HARKAT menyediakan produk/jasa dengan KUALITAS TERBAIK",
    "PT. HARKAT berhasil melalui PENGHORMATAN TERHADAP MANUSIA DAN PERBAIKAN BERKELANJUTAN"
  ],
  mission: "Mengembangkan keterampilan dan pengetahuan dalam bidang teknik, pengadaan, layanan pemeliharaan, dan instalasi, serta memperkuat kerja tim melalui perekrutan, pelatihan, pendidikan, dan pengalaman guna mencapai produk/layanan berkualitas tertinggi, proses kerja yang paling produktif/efisien, dan pengembalian tertinggi bagi pemegang saham."
};

export const values = [
  {
    id: 1,
    title: "Pegawai Profesional Beragama",
    description: "Bekerja dengan integritas yang tinggi, tanggung jawab, etika, kerja tim, dan moralitas.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Kualitas, Kesehatan, dan Keselamatan",
    description: "Menempatkan kualitas, kesehatan, dan keselamatan sebagai prioritas utama.",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Tanggung Jawab Sosial",
    description: "Berkomitmen terhadap lingkungan dan masyarakat sekitar.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Pembelajaran Berkelanjutan",
    description: "Terus belajar dan berinovasi untuk memberikan layanan terbaik.",
    icon: "BookOpen"
  }
];

export const companyImages = {
  worker: "https://customer-assets.emergentagent.com/job_profile-modern-2/artifacts/oxrl4y74_image.png",
  workerCircular: "https://customer-assets.emergentagent.com/job_profile-modern-2/artifacts/q8j45h8f_image.png",
  logo: "https://customer-assets.emergentagent.com/job_profile-modern-2/artifacts/f0tvsa3n_image.png"
};

export const marketingCopy = {
  services: {
    title: "Layanan Berkelas Dunia",
    subtitle: "Kami Tidak Hanya Membangun, Kami Menciptakan Karya",
    tagline: "Dipercaya oleh 50+ perusahaan terkemuka di Indonesia"
  },
  about: {
    title: "Keahlian yang Terbukti",
    subtitle: "15+ Tahun Pengalaman Membangun Masa Depan",
    tagline: "Safety First, Quality Always"
  },
  portfolio: {
    title: "Portfolio Kebanggaan Kami",
    subtitle: "Setiap Proyek adalah Masterpiece",
    tagline: "100+ Proyek Selesai dengan Sempurna"
  },
  cta: {
    primary: "Wujudkan Proyek Impian Anda Bersama Kami",
    secondary: "Konsultasi Gratis - Tim Profesional Siap Membantu 24/7"
  }
};

export const projects = [
  {
    id: 1,
    title: "Waterproofing",
    category: "Waterproofing",
    image: "https://nemuftsdmjzkzcygkjpg.supabase.co/storage/v1/object/public/assets-devaq/pt-harkat-bangkit-jaya/waterproofing.webp",
    description: "Pengerjaan Water Proofing, Inject, & Sealant oleh tenaga ahli PT. Harkat Bangkit Jaya untuk ketahanan struktur jangka panjang."
  },
  {
    id: 2,
    title: "Maquete",
    category: "Maquete",
    image: "https://nemuftsdmjzkzcygkjpg.supabase.co/storage/v1/object/public/assets-devaq/pt-harkat-bangkit-jaya/maquete.webp",
    description: "Visualisasi proyek melalui Scale Model & Maquette dengan detail presisi untuk mempresentasikan konsep arsitektur secara nyata."
  },
  {
    id: 3,
    title: "Desain Interior Modern",
    category: "Interior Design",
    image: "https://nemuftsdmjzkzcygkjpg.supabase.co/storage/v1/object/public/assets-devaq/pt-harkat-bangkit-jaya/desain-interior-modern.webp",
    description: "Desain interior ruang kantor yang modern dan fungsional"
  },
  {
    id: 4,
    title: "Electrical Installation Panel",
    category: "ELECTRICAL",
    image: "https://nemuftsdmjzkzcygkjpg.supabase.co/storage/v1/object/public/assets-devaq/pt-harkat-bangkit-jaya/instalasi-mep.webp",
    description: "Instalasi sistem mekanikal, elektrikal, dan plumbing"
  },
  {
    id: 5,
    title: "Rope Access Technic",
    category: "Rope Access Technic",
    image: "https://nemuftsdmjzkzcygkjpg.supabase.co/storage/v1/object/public/assets-devaq/pt-harkat-bangkit-jaya/rope.webp",
    description: "Layanan Cleaning Build System RAT (Rope Access Technic) oleh tim ahli untuk perawatan fasad gedung tinggi secara aman dan efisien."
  },
  {
    id: 6,
    title: "Arsitektur Bangunan",
    category: "Architecture",
    image: "https://nemuftsdmjzkzcygkjpg.supabase.co/storage/v1/object/public/assets-devaq/pt-harkat-bangkit-jaya/arsitektur-bangunan.webp",
    description: "Desain arsitektur bangunan dengan konsep modern minimalis"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Budi Santoso",
    position: "Project Manager",
    company: "PT. Maju Bersama",
    comment: "PT. Harkat Bangkit Jaya memberikan layanan yang sangat profesional. Pekerjaan selesai tepat waktu dengan kualitas yang memuaskan.",
    rating: 5
  },
  {
    id: 2,
    name: "Siti Nurhaliza",
    position: "Facility Manager",
    company: "Grand Mall Tasikmalaya",
    comment: "Tim yang sangat kompeten dan berpengalaman. Maintenance gedung kami ditangani dengan sangat baik dan safety menjadi prioritas utama.",
    rating: 5
  },
  {
    id: 3,
    name: "Ahmad Hidayat",
    position: "Owner",
    company: "Hotel Tasik Indah",
    comment: "Kualitas pekerjaan luar biasa! Dari desain interior hingga instalasi MEP, semuanya dikerjakan dengan detail dan profesional.",
    rating: 5
  },
  {
    id: 4,
    name: "Rina Wijaya",
    position: "Developer",
    company: "Tasik Property",
    comment: "Sangat puas dengan hasil kerja PT. Harkat. Harga kompetitif dengan hasil yang maksimal. Highly recommended!",
    rating: 5
  }
];

export const stats = [
  {
    id: 1,
    number: "100+",
    label: "Proyek Selesai",
    icon: "CheckCircle"
  },
  {
    id: 2,
    number: "50+",
    label: "Klien Puas",
    icon: "Users"
  },
  {
    id: 3,
    number: "24/7",
    label: "Layanan Support",
    icon: "Clock"
  },
  {
    id: 4,
    number: "100%",
    label: "Komitmen Kualitas",
    icon: "Award"
  }
];

export const clients = [
  "PT. Maju Bersama",
  "Grand Mall Tasikmalaya",
  "Hotel Tasik Indah",
  "Tasik Property",
  "Bank Mandiri Tasikmalaya",
  "Rumah Sakit Umum Tasikmalaya"
];
